import { render, staticRenderFns } from "./SelezioneTeam.vue?vue&type=template&id=a7df2480&scoped=true"
import script from "./SelezioneTeam.vue?vue&type=script&lang=js"
export * from "./SelezioneTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7df2480",
  null
  
)

export default component.exports